import { gql } from '@apollo/client';

export const GET_CAAS_AVAILABILITY = gql`
  query caasAvailability($args: RiseAIAnalysisDataInput!) {
    caasAvailability(args: $args)
  }
`;

export const GET_RISE_AI_ANALYSIS_DATA = gql`
  query riseAIAnalysisData($args: RiseAIAnalysisDataInput!) {
    riseAIAnalysisData(args: $args) {
      findingsCount
    }
  }
`;
